module.exports = __webpack_public_path__ + "static/typologische_mischung-20cd3b240cd6bf897d5a04b30fe4f78a.png";